import styled from '@emotion/styled'
import theme from '~/gatsby-plugin-theme-ui'

export const SliderWrapper = styled.div`
  /* https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.css */
  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
  }
  .slick-track:before,
  .slick-track:after {
    display: table;

    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  /* Overrides */

  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    display: flex !important;
    height: inherit !important;

    &:focus:not(:focus-visible) {
      outline: none;
    }
  }

  .slick-dots {
    display: flex !important;
    justify-content: center;
    list-style-type: none;
    margin: 16px 0 0;
    padding: 0;

    li {
      margin: 0 4px;
      button {
        appearance: none;
        background-color: transparent;
        border: 0;
        color: transparent;
        cursor: pointer;
        display: inline-block;
        height: 28px;
        overflow: hidden;
        padding: 0;
        position: relative;
        width: 24px;

        &:before {
          background-color: #dcd9d8;
          border-radius: 50%;
          content: '';
          display: block;
          height: 12px;
          left: 6px;
          position: absolute;
          top: 8px;
          transition: 'background-color 0.6s ease-in-out';
          width: 12px;
        }

        &:focus:not(:focus-visible) {
          outline: none;
        }
      }
    }

    li.slick-active button:before {
      background-color: ${theme.colors.brandPrimary};
    }

    @media only screen and (min-width: 640px) {
      margin-top: 32px;
    }
  }
`
